import Helpers from '../modules/Helpers'
import Reveal from '../modules/Reveal'

// Listen to all accordion toggle buttons in order 
// to open and close corresponding accordion.
new Helpers(document.getElementsByTagName('body')).delegateEventListener('.accordion-toggle',(e) => {
    e.preventDefault()

    const currentAccordion = e.target.closest('.accordion-toggle')

    // Check if element has `aria-controls` attribute
    // as it's used to determine the element to toggle.
    // If no attribute set, then toggle the next element.
    const hasAriaControlsAttr = new Helpers(currentAccordion).hasAriaControlsAttr()

    const ariaControlsValue = currentAccordion.getAttribute('aria-controls')
    const ariaControlsElement = document.getElementById(ariaControlsValue)
    const nextSiblingElement = currentAccordion.nextElementSibling

    // If element has `aria-controls` attribute, then toggle
    // the element its value refers to (by `id`), otherwise toggle
    // the next sibling element.
    const accordion = hasAriaControlsAttr ? ariaControlsElement : nextSiblingElement

    // Toggle the active class on all elements with the same aria-controls value
    const allToggles = document.querySelectorAll(`[aria-controls="${ariaControlsValue}"]`)
    allToggles.forEach(toggle => {
        new Helpers(toggle).toggleClass('accordion-toggle--active')
    })

    new Reveal(accordion).toggle('accordion--active')
})
